export default __webpack_public_path__ + "static/jasmine_cottage-f2dafa341ed25179c567a5330814d623.png";